import { render, staticRenderFns } from "./VehiculeForm.vue?vue&type=template&id=5e2fabde&scoped=true&"
import script from "./VehiculeForm.vue?vue&type=script&lang=js&"
export * from "./VehiculeForm.vue?vue&type=script&lang=js&"
import style0 from "./VehiculeForm.vue?vue&type=style&index=0&id=5e2fabde&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5e2fabde",
  null
  
)

export default component.exports